import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';

window.__initCalculator = function (settings, calculate) {
    ReactDOM.render(
        <React.StrictMode>
            <App settings={settings.data} form={settings.form} getTotal={calculate}/>
        </React.StrictMode>,
        document.getElementById('root')
    );
}
